import { render } from "./finishPage.vue?vue&type=template&id=c99836f6&scoped=true"
import script from "./finishPage.vue?vue&type=script&lang=js"
export * from "./finishPage.vue?vue&type=script&lang=js"

import "./finishPage.vue?vue&type=style&index=0&id=c99836f6&lang=scss&scoped=true"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/adQuestionsPop/finishPage.vue'],['render',render],['__scopeId',"data-v-c99836f6"],['__file',"finishPage.vue"]])

export default __exports__